import type { ReactNode } from "react";
import type { FeatureFlagKey } from "@/types/feature-flags.generated";

export const HOME = "home";

export enum SidebarItemType {
  Nest = "nest",
}

export type SidebarItem = {
  key: string;
  title: string;
  icon?: ReactNode;
  href?: string;
  type?: SidebarItemType.Nest;
  startContent?: ReactNode;
  endContent?: ReactNode;
  items?: SidebarItem[];
  className?: string;
  isDisabled?: boolean;
  /** Action items (e.g. Notifications) have no href; they run this instead of navigating. */
  onPress?: () => void;
  featureFlag?: FeatureFlagKey;
  // Permission check properties
  requirePermission?: {
    action: string;
    resource: string;
    scopeId?: string;
  };
};

export type SidebarProps = {
  items: SidebarItem[];
  isCompact?: boolean;
  hideEndContent?: boolean;
  iconClassName?: string;
  defaultSelectedKey: string;
  onSelect?: (key: string) => void;
  className?: string;
};
